import styled from "styled-components";

export const DrawerHeadingUnderlined = styled.div`
    padding-bottom: 5%;
    border-bottom: 1px solid #f3f4f7;
`;

export const RowTyped = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const DrawerTyped = styled.div`
    width: 50%; 
    font-weight: 600;
    font-size: 13px;
    font-family: Manrope !important;
`;

export const DrawerUser = styled.div`
    font-size: 12px; 
    font-weight: 500; 
    color: #5A6C87; 
    width: 50%; 
    margin-bottom: 4px; 
    margin-right: 5px; 
    text-align: right;
`;

export const DrawerDescription = styled.div`
    font-size: 12px; 
    margin-top: 2%; 
    font-weight: 500; 
    color: #48566B;
`;

export const DrawerTimeline = styled.div`
    font-size: 12px;
    color: #7688A3; 
    margin-top: 4px; 
    font-weight: 500
`;